import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";

const GlobalMultiSelectId = ({
  label,
  sx,
  arrayState,
  arraySetState,
  data,
  keys,
  disabled,
  fullWidth,
}) => {
  const handleChange = (event) => {
    const value = event.target.value;
    if (value.includes("all")) {
      //IF ALL selected
      if (arrayState?.length == data?.length) {
        //IF THE SELCTED ARRAY ALREADY FULL WITH TOTL NO OF DATA THEN IT WILL BE THE ALL ARRAY STATE WILLL BE CLEAR
        arraySetState([]);
      } else {
        //OTHER WISE THE ALL SELECTED DATA WILL BE PUSHED TO THE ARRAY STATE
        arraySetState(data?.map((obj) => obj[keys?.value]));
      }
    } else {
      arraySetState(value);
    }
  };
  const isAllSelected = arrayState?.length === data?.length;
  return (
    <FormControl
      fullWidth={fullWidth}
      sx={!fullWidth ? { minWidth: "220px", maxWidth: "220px", ...sx } : null}
    >
      <InputLabel>{label || "Label Name"}</InputLabel>
      <Select
        disabled={disabled}
        label={label || "Label Name"}
        multiple
        value={arrayState || []}
        onChange={handleChange}
        renderValue={(selected) =>
          data
            ?.filter((item) => selected.includes(item[keys.value]))
            .map((item) => item[keys.id])
            .join(", ")
        }
      >
        <MenuItem value="all">
          <Checkbox checked={isAllSelected} />
          <ListItemText primary="Select All" />
        </MenuItem>
        {data?.map((obj) => (
          <MenuItem key={obj[keys?.id]} value={obj[keys?.value]}>
            <Checkbox checked={arrayState?.indexOf(obj[keys?.value]) > -1} />
            <ListItemText primary={obj[keys?.id]} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GlobalMultiSelectId;
